export default "/images/agreflor-logo.png?99048d5c37efdec4055ca3c8531dfd13";